<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (alt)="alt()"
  (cancel)="cancel()"
  (confirm)="confirmImportCropFields($event)"
  data-test="import-cropfields"
>
  <div class="flex--row flex--gutter">
    <div class="flex__child--auto spacing--padding-all spacing--margin-bottom">
      {{ getModalDescription() }}
    </div>
  </div>

  <div class="flex--row flex--gutter">
    @if (this.showProviderField) {
      <mat-form-field class="flex__child--auto">
        <mat-label>
          {{ 'provider' | translate }}
        </mat-label>
        <mat-select formControlName="provider" data-test="import-cropfield-provider">
          @for (provider of data.providers; track provider) {
            <mat-option [value]="provider">
              {{ getProviderName(provider) }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field class="flex__child--auto">
      <mat-label>
        {{ 'year' | translate }}
      </mat-label>
      <mat-select formControlName="year" data-test="import-cropfield-year">
        @for (year of data.years; track year) {
          <mat-option [value]="year">
            {{ year }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>
        {{ 'customer' | translate }}
      </mat-label>
      <input
        type="text"
        [placeholder]="'customer' | translate"
        matInput
        formControlName="externalCustomer"
        [matAutocomplete]="customerAutocomplete"
        data-test="import-cropfield-customer"
      />
      <mat-autocomplete #customerAutocomplete="matAutocomplete" [displayWith]="displayCustomer()">
        @for (customer of filteredCustomers$ | async; track customer) {
          <mat-option [value]="customer.farmId" data-test="edit-cropfield-crop-option">
            {{ customer.farmDesignator }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label> {{ getPlaceholderForFarmId() }} </mat-label>
      <input
        matInput
        [placeholder]="getPlaceholderForFarmId()"
        formControlName="farmId"
        data-test="import-cropfield-customer-external-id"
      />
    </mat-form-field>
  </div>
</agr-form-dialog>
